import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-square-skeleton',
  templateUrl: './square-skeleton.component.html',
  styleUrls: ['./square-skeleton.component.css']
})
export class SquareSkeletonComponent implements OnInit {

  @Input() count:number = 1;

  @Input() width: string = "200px";

  @Input() height: string = "200px";

  constructor() { }

  ngOnInit(): void {
  }

  loopCounter = () => {
    return [...Array(this.count).keys()]
  }

}
